/* Nitely PDP — รอบแก้ 2 ก.ย.
   · แกลเลอรีปัดซ้ายขวาได้ (scroll-snap) + ทัมบ์/จุด/ลูกศร
   · วิดีโอเล่นเองแบบปิดเสียงเมื่อเลื่อนมาถึง · มีปุ่มเปิดเสียง · หยุดเมื่อเลื่อนผ่าน
   · แถบล่างมือถือ = เพิ่มลงตะกร้าจริง ไม่ใช่แค่เลื่อนหน้า */
(function(){
  var root = document.querySelector('.npdp');
  if(!root) return;

  /* ---------------- แกลเลอรี ---------------- */
  var track  = root.querySelector('[data-np-track]');
  var slides = track ? [].slice.call(track.querySelectorAll('[data-np-slide]')) : [];
  var thumbs = [].slice.call(root.querySelectorAll('[data-np-thumb]'));
  var dotBox = root.querySelector('[data-np-gdots]');
  var gPrev  = root.querySelector('[data-np-gprev]');
  var gNext  = root.querySelector('[data-np-gnext]');
  var dots   = [];
  var cur    = parseInt(root.getAttribute('data-np-start') || '0', 10) || 0;
  var settle, gliding;

  var canAuto = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function clamp(i){ return Math.max(0, Math.min(i, slides.length - 1)); }

  function stopOthers(except){
    root.querySelectorAll('.np-gslide video').forEach(function(v){
      if(v === except) return;
      if(!v.paused){ try{ v.pause(); }catch(e){} }
      try{ v.currentTime = 0; }catch(e){}
    });
  }

  function paint(i){
    cur = clamp(i);
    thumbs.forEach(function(b, n){ b.classList.toggle('on', n === cur); });
    dots.forEach(function(d, n){ d.classList.toggle('on', n === cur); });
    if(gPrev) gPrev.disabled = cur <= 0;
    if(gNext) gNext.disabled = cur >= slides.length - 1;

    var vid = slides[cur] ? slides[cur].querySelector('video') : null;
    stopOthers(vid);
    if(vid && canAuto){
      /* เล่นเองได้เฉพาะตอนปิดเสียง — เป็นกฎของเบราว์เซอร์ทุกตัว */
      var p = vid.play();
      if(p && p.catch) p.catch(function(){});
    }
  }

  function goTo(i, smooth){
    if(!track || !slides.length) return;
    i = clamp(i);
    var to = slides[i].offsetLeft - track.offsetLeft;
    /* Chrome ยกเลิก smooth scroll ตอน scroll-snap เป็น mandatory → ปิดชั่วคราว */
    gliding = true;
    track.style.scrollSnapType = 'none';
    try { track.scrollTo({ left: to, behavior: smooth === false ? 'auto' : 'smooth' }); }
    catch(e){ track.scrollLeft = to; }
    clearTimeout(settle);
    settle = setTimeout(function(){
      if(Math.abs(track.scrollLeft - to) > 4) track.scrollLeft = to;
      track.style.scrollSnapType = '';
      gliding = false;
      paint(i);
    }, smooth === false ? 40 : 420);
    paint(i);
  }

  if(track && slides.length){
    /* --- ตั้งค่าวิดีโอให้เล่นเองได้ + ปุ่มเปิดเสียง --- */
    slides.forEach(function(s){
      var v = s.querySelector('video');
      if(!v) return;
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.addEventListener('play', function(){ stopOthers(v); });

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'np-unmute';
      function label(){
        b.textContent = v.muted ? '🔇 แตะเพื่อเปิดเสียง' : '🔊 ปิดเสียง';
        b.setAttribute('aria-label', v.muted ? 'เปิดเสียงวิดีโอ' : 'ปิดเสียงวิดีโอ');
      }
      label();
      b.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        v.muted = !v.muted;
        if(!v.muted){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
        label();
      });
      v.addEventListener('volumechange', label);
      s.appendChild(b);
    });

    if(dotBox && slides.length > 1){
      slides.forEach(function(s, n){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'np-gdot';
        b.setAttribute('aria-label', 'ไปที่ภาพที่ ' + (n + 1));
        b.addEventListener('click', function(){ goTo(n); });
        dotBox.appendChild(b);
        dots.push(b);
      });
    }

    thumbs.forEach(function(b){
      b.addEventListener('click', function(){
        goTo(parseInt(b.getAttribute('data-i') || '0', 10));
      });
    });

    if(gPrev) gPrev.addEventListener('click', function(){ goTo(cur - 1); });
    if(gNext) gNext.addEventListener('click', function(){ goTo(cur + 1); });

    /* ปัดนิ้วแล้ว sync ทัมบ์/จุด — ใช้ IntersectionObserver เป็นหลัก */
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        if(gliding) return;
        var best = null;
        entries.forEach(function(e){
          if(e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
        });
        if(best && best.intersectionRatio >= 0.55){
          paint(parseInt(best.target.getAttribute('data-i') || '0', 10));
        }
      }, { root: track, threshold: [0.55, 0.8, 1] });
      slides.forEach(function(s){ io.observe(s); });

      /* หยุดวิดีโอเมื่อเลื่อนแกลเลอรีพ้นจอ */
      new IntersectionObserver(function(entries){
        if(!entries[0].isIntersecting) stopOthers(null);
        else paint(cur);
      }, { threshold: 0.15 }).observe(track);
    }

    /* สำรอง: ฟัง scroll event ด้วย */
    var st;
    track.addEventListener('scroll', function(){
      if(gliding) return;
      clearTimeout(st);
      st = setTimeout(function(){
        var w = track.clientWidth || 1;
        paint(Math.round(track.scrollLeft / w));
      }, 90);
    }, { passive: true });

    /* ลูกศรซ้าย-ขวาบนคีย์บอร์ด */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(cur + 1); }
      if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(cur - 1); }
    });

    window.addEventListener('resize', function(){
      clearTimeout(st);
      st = setTimeout(function(){ goTo(cur, false); }, 180);
    });

    goTo(cur, false);
  }

  /* ---------------- เลือกแพ็ก ---------------- */
  var form     = root.querySelector('#npdpForm');
  var hidden   = root.querySelector('#npdpVarId');
  var cta      = root.querySelector('[data-np-cta]');
  var sPrice   = root.querySelector('[data-np-sticky-price]');
  var sCompare = root.querySelector('[data-np-sticky-compare]');

  root.querySelectorAll('[data-np-tier]').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('[data-np-tier]').forEach(function(x){ x.classList.remove('sel'); });
      t.classList.add('sel');
      var price = t.getAttribute('data-price');
      var comp  = t.getAttribute('data-compare') || '';
      var avail = t.getAttribute('data-available') === 'true';
      if(hidden) hidden.value = t.getAttribute('data-vid');
      if(cta){
        cta.innerHTML = avail ? ('เพิ่มลงตะกร้า — ' + price) : 'สินค้าหมดชั่วคราว';
        cta.disabled = !avail;
      }
      if(sPrice)   sPrice.innerHTML = price;
      if(sCompare) sCompare.innerHTML = comp;
      var mi = t.getAttribute('data-mi');
      if(mi !== null && mi !== '') goTo(parseInt(mi, 10));
      var u = new URL(window.location.href);
      u.searchParams.set('variant', t.getAttribute('data-vid'));
      window.history.replaceState({}, '', u);
    });
  });

  /* ---------------- แถบล่างมือถือ ---------------- */
  var sticky = root.querySelector('[data-np-sticky]');
  if(sticky && cta && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(cta);
  }

  var sBtn = root.querySelector('[data-np-sticky-btn]');
  if(sBtn){
    sBtn.addEventListener('click', function(){
      var id = hidden && hidden.value;
      if(!id){ if(form) form.submit(); return; }
      var label = sBtn.innerHTML;
      sBtn.disabled = true;
      sBtn.innerHTML = 'กำลังเพิ่ม…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){
        sBtn.disabled = false;
        sBtn.innerHTML = label;
        if(form) form.submit();   /* สำรอง: ส่งฟอร์มปกติ */
      });
    });
  }
})();
